export default "__VITE_ASSET__n9LSYIzIYIM$0Qh97YBz1A__"